var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('CustomerImportFailure',{attrs:{"modal":true},on:{"close":_vm.handleClose,"try-again":_vm.handleTryAgain}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }